const initialState = {
    isOpen: false,
    // Full org from the sidebar row — id/name/client_type for copy + deprecate PATCH
    organization: null,
    // Snapshotted from usersByOrgId at open (modal copy does not re-read child-org state)
    userCount: 0,
    isDeprecating: false,
};

export const NAME = 'deprecateOrgModal';

const handlers = {
    DEPRECATE_ORG_MODAL__OPEN_MODAL: (state, action) => {
        const { organization, userCount } = action.payload;
        return {
            ...state,
            isOpen: true,
            organization: organization || null,
            userCount: typeof userCount === 'number' ? userCount : 0,
        };
    },
    DEPRECATE_ORG_MODAL__CLOSE_MODAL: () => {
        return {
            ...initialState,
        };
    },
    DEPRECATE_ORG_MODAL__DEPRECATE_START: state => {
        return {
            ...state,
            isDeprecating: true,
        };
    },
    DEPRECATE_ORG_MODAL__DEPRECATE_SUCCESS: state => {
        return {
            ...state,
            isDeprecating: false,
        };
    },
    DEPRECATE_ORG_MODAL__DEPRECATE_FAIL: state => {
        return {
            ...state,
            isDeprecating: false,
        };
    },
};

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
export default function reducer(state = initialState, action) {
    let nextState = state;

    if (handlers[action.type]) {
        nextState = handlers[action.type](state, action);
    }

    return nextState;
}
